
import type {
  QueryRankingElementRankingAction,
  QueryRankingElementRankingDTO,
  QueryRankingPinnedElementDTO,
} from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type { QueryRankingElementActionConfig } from '../../composables/use-query-ranking-element-actions-config'
import type { Filter, RegularFilterConfig } from '../../models'

import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

import { useQueryRankingElementActionsConfig } from '../../composables/use-query-ranking-element-actions-config'

import { useScheduleFormat } from '../../composables/use-schedule-format'

import { CONTEXT_CONSTS } from '../../store/context/context.consts'
import { FiltersUtils } from '../../utils'
import { EpbBadge } from '../shared/epb-badge'
import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'RankingElementsListItem',
  components: {
    EpbText,
    EpbBadge,
  },
  props: {
    element: {
      type: Object as PropType<QueryRankingElementRankingDTO | QueryRankingPinnedElementDTO>,
      required: true,
    },
    hideSchedule: Boolean,
  },
  data(): Record<string, any> {
    return {
      baseClass: 'epb-ranking-elements-list-item',
    }
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context,
    }),
  },
  methods: {
    getActionConfig(action: QueryRankingElementRankingAction): QueryRankingElementActionConfig {
      return useQueryRankingElementActionsConfig().getActionConfig(action)
    },
    getFiltersTooltip(element: QueryRankingElementRankingDTO): string {
      const configs = Object.values(this.context.filters).map(({ config }: Filter) => config)
      const messages = this.$epb.messages.filters
      return Object.entries(element.filters)
        .map(([encodedId, encodedValues]: [string, string[]]) => {
          const config = FiltersUtils.findConfig(configs, {
            toolingId: encodedId,
          }) as RegularFilterConfig
          let label: string, valueLabels: string[]
          if (config) {
            label = FiltersUtils.getLabel(config, messages)
            valueLabels = encodedValues.map((encodedValue: string) => {
              const valueConfig = FiltersUtils.findValueConfig(config.values, {
                taggingId: encodedValue,
              })
              return valueConfig
                ? FiltersUtils.getValueLabel(config, valueConfig, messages)
                : encodedValue
            })
          } else {
            label = encodedId
            valueLabels = encodedValues
          }
          return `${label}: ${valueLabels.join(', ')}`
        }, [])
        .join('<br>')
    },
    getScheduleTooltip(element: QueryRankingElementRankingDTO): string {
      return useScheduleFormat(element.schedule)
    },
    areFiltersSet(element: QueryRankingElementRankingDTO): boolean {
      return Object.values(element.filters).some((value: string[]) => !!value.length)
    },
    isScheduleSet(element: QueryRankingElementRankingDTO): boolean {
      return !!element.schedule.activationDate || !!element.schedule.deactivationDate
    },
  },
})
